module.exports = __webpack_public_path__ + "img/B12-20190411_02.738fb615.jpg";